
<div class="school-students-container">
  <app-school-students-list></app-school-students-list>
</div>
